export interface Movie {
  id: string;
  title: string;
  year: number;
  genres: string[];
  rating: number;
  duration: number;
  country: string;
  director: string;
  cast: string[];
  poster: string;
  backdrop: string;
  still2: string;
  synopsis: string;
  tags: string[];
  popularity: number;
}

export const movies: Movie[] = [
  {
    id: 'spring-night',
    title: '春夜之约',
    year: 2019,
    genres: ['爱情', '剧情'],
    rating: 8.6,
    duration: 118,
    country: '韩国',
    director: '朴敏浩',
    cast: ['李采潭', '金志勋', '徐允儿'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20romance%20film%20poster%2C%20elegant%20young%20woman%20in%20soft%20evening%20window%20light%2C%20deep%20navy%20and%20warm%20gold%20tones%2C%20moody%20atmospheric%20lighting%2C%20film%20grain%20texture%2C%20editorial%20portrait%20photography&width=600&height=900&seq=lct-poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%2C%20young%20woman%20standing%20by%20a%20rainy%20city%20window%20at%20night%2C%20deep%20blue%20and%20warm%20gold%20color%20grade%2C%20moody%20soft%20lighting%2C%20film%20grain%2C%20wide%20composition&width=1280&height=720&seq=lct-still-01&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20film%20still%2C%20couple%20walking%20under%20warm%20street%20lamps%20on%20a%20spring%20night%2C%20deep%20blue%20shadows%20with%20golden%20highlights%2C%20cinematic%20wide%20shot%2C%20film%20grain&width=1280&height=720&seq=lct-still-01b&orientation=landscape',
    synopsis: '在一座被春雨浸润的城市里，花店员工与旧日恋人在多年后意外重逢。两人带着各自未说出口的遗憾，在一场又一场春夜的约会中重新认识彼此。影片以克制细腻的镜头语言，讲述关于时间、告别与再次选择的温柔故事。',
    tags: ['文艺爱情', '重逢', '城市夜晚'],
    popularity: 96,
  },
  {
    id: 'dark-alley',
    title: '暗巷',
    year: 2020,
    genres: ['悬疑', '犯罪'],
    rating: 8.9,
    duration: 124,
    country: '韩国',
    director: '郑在勋',
    cast: ['李采潭', '崔民载', '韩素拉'],
    poster: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%2C%20determined%20woman%20silhouette%20in%20a%20narrow%20dark%20alley%2C%20deep%20navy%20blue%20and%20amber%20gold%20contrast%2C%20dramatic%20hard%20lighting%2C%20gritty%20film%20noir%20mood%2C%20high%20detail&width=600&height=900&seq=lct-poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Film%20noir%20crime%20scene%2C%20narrow%20wet%20alley%20at%20night%20with%20flickering%20lamps%2C%20figure%20walking%20away%20from%20camera%2C%20deep%20blue%20and%20amber%20color%20grade%2C%20moody%20cinematic%20wide%20shot&width=1280&height=720&seq=lct-still-02&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Detective%20thriller%20film%20still%2C%20woman%20examining%20crime%20scene%20photos%20on%20a%20desk%20under%20lamp%20light%2C%20dark%20navy%20tones%20with%20golden%20glow%2C%20cinematic%20close%20composition&width=1280&height=720&seq=lct-still-02b&orientation=landscape',
    synopsis: '一桩多年悬而未决的失踪案，让一名执着的地方记者走进了城市最阴暗的角落。随着调查深入，她发现真相与自己的过去紧密相连。影片节奏紧凑，层层反转，探讨正义的代价与人性的灰色地带。',
    tags: ['犯罪悬疑', '调查', '反转'],
    popularity: 99,
  },
  {
    id: 'north-of-han',
    title: '汉江以北',
    year: 2018,
    genres: ['剧情', '家庭'],
    rating: 8.3,
    duration: 131,
    country: '韩国',
    director: '李承宇',
    cast: ['李采潭', '朴正洙', '尹美娜'],
    poster: 'https://readdy.ai/api/search-image?query=Drama%20film%20poster%2C%20thoughtful%20woman%20looking%20across%20a%20wide%20river%20at%20dusk%2C%20deep%20navy%20sky%20with%20warm%20gold%20horizon%2C%20restrained%20elegant%20composition%2C%20cinematic%20grain&width=600&height=900&seq=lct-poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Emotional%20Korean%20family%20drama%20still%2C%20apartment%20rooftop%20overlooking%20a%20river%20city%20at%20dusk%2C%20deep%20blue%20evening%20with%20golden%20window%20lights%2C%20cinematic%20wide%20composition&width=1280&height=720&seq=lct-still-03&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Family%20drama%20film%20still%2C%20quiet%20dinner%20table%20scene%20with%20warm%20lamp%20light%20and%20shadows%2C%20muted%20navy%20and%20gold%20color%20grade%2C%20intimate%20cinematic%20framing&width=1280&height=720&seq=lct-still-03b&orientation=landscape',
    synopsis: '一个普通家庭在城市的变迁中努力维系彼此。母亲经营着一家老旧餐馆，女儿在外打拼多年后回到故乡。两代人的观念冲突与沉默的爱，在日复一日的相处中慢慢和解。影片温柔而真实，直击当代家庭的情感核心。',
    tags: ['家庭', '亲情', '现实题材'],
    popularity: 88,
  },
  {
    id: 'silent-confession',
    title: '无声告白',
    year: 2021,
    genres: ['剧情', '家庭'],
    rating: 8.7,
    duration: 116,
    country: '韩国',
    director: '金娜英',
    cast: ['李采潭', '吴成宇', '林智恩'],
    poster: 'https://readdy.ai/api/search-image?query=Quiet%20drama%20film%20poster%2C%20pensive%20woman%20seated%20near%20a%20window%20with%20soft%20daylight%2C%20deep%20navy%20and%20muted%20gold%20palette%2C%20understated%20elegant%20composition%2C%20subtle%20film%20grain&width=600&height=900&seq=lct-poster-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Melancholic%20family%20drama%20still%2C%20woman%20writing%20a%20letter%20at%20a%20wooden%20desk%20by%20window%20light%2C%20deep%20blue%20shadows%20with%20warm%20gold%20sunlight%2C%20cinematic%20close%20shot&width=1280&height=720&seq=lct-still-04&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Moving%20family%20film%20still%2C%20mother%20and%20daughter%20sharing%20a%20quiet%20moment%20on%20a%20park%20bench%20in%20autumn%2C%20muted%20navy%20and%20gold%20grade%2C%20cinematic%20wide%20composition&width=1280&height=720&seq=lct-still-04b&orientation=landscape',
    synopsis: '一位母亲始终无法对家人说出那句藏在心底多年的话。一次意外的家庭聚会，让所有被压抑的情绪逐渐浮出水面。影片以极简的对话与大量的留白，刻画了东亚家庭中那些说不出口的爱与歉意。',
    tags: ['家庭', '情感', '催泪'],
    popularity: 92,
  },
  {
    id: 'light-chaser',
    title: '追光者',
    year: 2022,
    genres: ['剧情', '励志'],
    rating: 8.4,
    duration: 127,
    country: '韩国',
    director: '张铉成',
    cast: ['李采潭', '高俊熙', '徐道贤'],
    poster: 'https://readdy.ai/api/search-image?query=Inspirational%20drama%20film%20poster%2C%20determined%20young%20woman%20looking%20toward%20bright%20horizon%2C%20deep%20navy%20silhouette%20with%20warm%20golden%20light%20rays%2C%20hopeful%20cinematic%20composition%2C%20film%20grain&width=600&height=900&seq=lct-poster-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Uplifting%20film%20still%2C%20woman%20running%20along%20a%20coastal%20road%20at%20golden%20hour%2C%20deep%20blue%20sea%20with%20warm%20gold%20sunlight%2C%20cinematic%20wide%20shot%2C%20motion%20energy&width=1280&height=720&seq=lct-still-05&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Inspiring%20drama%20film%20still%2C%20woman%20practicing%20under%20a%20single%20stage%20spotlight%20in%20an%20empty%20hall%2C%20dark%20navy%20background%20with%20golden%20rim%20light%2C%20cinematic%20composition&width=1280&height=720&seq=lct-still-05b&orientation=landscape',
    synopsis: '失去舞台的舞者在人生低谷中重新出发，用一场几近不可能的演出证明自己。影片聚焦坚持与自我和解，用一段充满力量的旅程，讲述普通人如何在逆光之中依然选择向前。',
    tags: ['励志', '成长', '梦想'],
    popularity: 90,
  },
  {
    id: 'flower-in-mist',
    title: '雾中花',
    year: 2020,
    genres: ['悬疑', '爱情'],
    rating: 8.2,
    duration: 113,
    country: '韩国',
    director: '郑在勋',
    cast: ['李采潭', '申宇彬', '李하늘'],
    poster: 'https://readdy.ai/api/search-image?query=Mysterious%20romance%20film%20poster%2C%20woman%20partly%20hidden%20in%20morning%20fog%2C%20deep%20navy%20mist%20with%20faint%20warm%20gold%20glow%2C%20dreamlike%20ethereal%20mood%2C%20cinematic%20film%20grain&width=600&height=900&seq=lct-poster-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Atmospheric%20film%20still%2C%20lone%20figure%20on%20a%20misty%20wooden%20bridge%20at%20dawn%2C%20deep%20blue%20fog%20with%20warm%20gold%20lantern%20light%2C%20cinematic%20wide%20shot&width=1280&height=720&seq=lct-still-06&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Romantic%20mystery%20film%20still%2C%20woman%20holding%20a%20single%20flower%20in%20soft%20light%20through%20mist%2C%20muted%20navy%20and%20gold%20grade%2C%20intimate%20cinematic%20framing&width=1280&height=720&seq=lct-still-06b&orientation=landscape',
    synopsis: '一名摄影师在雾气弥漫的清晨拍下了一张模糊的照片，照片中的人却似乎并不存在。随着她追寻真相，一段跨越记忆与现实的爱情逐渐显露。影片将悬疑与浪漫交织，氛围感十足。',
    tags: ['悬疑爱情', '记忆', '氛围'],
    popularity: 85,
  },
  {
    id: 'the-way-home',
    title: '归途',
    year: 2016,
    genres: ['剧情', '家庭'],
    rating: 8.0,
    duration: 109,
    country: '韩国',
    director: '李承宇',
    cast: ['李采潭', '安圣哲', '朴恩静'],
    poster: 'https://readdy.ai/api/search-image?query=Warm%20drama%20film%20poster%2C%20woman%20carrying%20a%20small%20suitcase%20down%20a%20country%20road%2C%20deep%20navy%20dusk%20sky%20with%20warm%20gold%20sunset%2C%20nostalgic%20cinematic%20composition&width=600&height=900&seq=lct-poster-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Nostalgic%20film%20still%2C%20rural%20road%20at%20sunset%20with%20a%20lone%20traveler%2C%20deep%20blue%20shadow%20and%20warm%20golden%20sky%2C%20cinematic%20wide%20composition%20with%20film%20grain&width=1280&height=720&seq=lct-still-07&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Heartwarming%20film%20still%2C%20family%20gathered%20around%20a%20small%20village%20house%20at%20dusk%2C%20warm%20golden%20window%20light%20against%20deep%20navy%20evening%2C%20cinematic%20composition&width=1280&height=720&seq=lct-still-07b&orientation=landscape',
    synopsis: '离开故乡多年的女性在城市失落之后踏上了回家的路。熟悉的街道、陌生的变化，还有始终守候的亲人，让她重新找回了出发的勇气。影片朴素动人，关于归属与和解。',
    tags: ['返乡', '亲情', '治愈'],
    popularity: 80,
  },
  {
    id: 'seventh-letter',
    title: '第七封信',
    year: 2019,
    genres: ['悬疑', '剧情'],
    rating: 8.5,
    duration: 121,
    country: '韩国',
    director: '金娜英',
    cast: ['李采潭', '崔民载', '郑有珍'],
    poster: 'https://readdy.ai/api/search-image?query=Suspense%20drama%20film%20poster%2C%20woman%20reading%20an%20old%20letter%20by%20lamp%20light%2C%20deep%20navy%20shadows%20with%20warm%20gold%20glow%2C%20intriguing%20cinematic%20mood%2C%20film%20grain&width=600&height=900&seq=lct-poster-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Mystery%20film%20still%2C%20desk%20covered%20with%20old%20letters%20and%20photographs%20under%20a%20lamp%2C%20deep%20blue%20shadows%20with%20warm%20gold%20light%2C%20cinematic%20close%20composition&width=1280&height=720&seq=lct-still-08&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Tense%20drama%20film%20still%2C%20woman%20standing%20in%20an%20old%20library%20corridor%20lit%20by%20golden%20lamps%2C%20deep%20navy%20shadows%2C%20cinematic%20wide%20shot&width=1280&height=720&seq=lct-still-08b&orientation=landscape',
    synopsis: '整理祖母遗物时，她发现了七封从未寄出的信。每一封信都指向一段被遗忘的往事，也揭开了一个家族隐瞒多年的秘密。影片结构精巧，悬念与情感并重。',
    tags: ['悬疑', '家族秘密', '书信'],
    popularity: 91,
  },
  {
    id: 'sea-and-shore',
    title: '海与岸',
    year: 2021,
    genres: ['爱情', '剧情'],
    rating: 8.3,
    duration: 122,
    country: '韩国',
    director: '朴敏浩',
    cast: ['李采潭', '金志勋', '白承贤'],
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20poster%2C%20woman%20standing%20at%20the%20shoreline%20with%20wind%20in%20her%20hair%2C%20deep%20navy%20sea%20with%20warm%20gold%20sunset%20glow%2C%20bittersweet%20cinematic%20mood&width=600&height=900&seq=lct-poster-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20seaside%20film%20still%2C%20two%20figures%20walking%20along%20an%20empty%20beach%20at%20dusk%2C%20deep%20blue%20ocean%20with%20warm%20golden%20sky%2C%20wide%20composition%20with%20film%20grain&width=1280&height=720&seq=lct-still-09&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Melancholic%20romance%20film%20still%2C%20woman%20gazing%20at%20the%20sea%20from%20a%20lighthouse%20window%2C%20deep%20navy%20tones%20with%20warm%20gold%20light%2C%20cinematic%20intimate%20framing&width=1280&height=720&seq=lct-still-09b&orientation=landscape',
    synopsis: '在海边小镇经营民宿的女性，遇见了一位每年夏天都会来此停留的旅人。他们约定只在夏天相见，却在一次次离别中逐渐看清彼此的心意。影片像海浪一样温柔而绵长。',
    tags: ['海边', '约定', '文艺爱情'],
    popularity: 87,
  },
  {
    id: 'winter-echo',
    title: '冬日回声',
    year: 2018,
    genres: ['剧情'],
    rating: 7.9,
    duration: 105,
    country: '韩国',
    director: '张铉成',
    cast: ['李采潭', '吴成宇', '尹美娜'],
    poster: 'https://readdy.ai/api/search-image?query=Quiet%20winter%20drama%20film%20poster%2C%20woman%20in%20a%20warm%20coat%20in%20falling%20snow%2C%20deep%20navy%20blue%20night%20with%20warm%20gold%20street%20light%2C%20contemplative%20cinematic%20mood&width=600&height=900&seq=lct-poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Winter%20film%20still%2C%20snowy%20city%20street%20at%20night%20with%20warm%20shop%20lights%2C%20deep%20blue%20snow%20with%20golden%20glow%2C%20cinematic%20wide%20composition%20with%20film%20grain&width=1280&height=720&seq=lct-still-10&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Reflective%20drama%20film%20still%2C%20woman%20looking%20out%20of%20a%20frosted%20window%20with%20warm%20interior%20light%2C%20deep%20navy%20tones%20with%20gold%20accents%2C%20cinematic%20close%20composition&width=1280&height=720&seq=lct-still-10b&orientation=landscape',
    synopsis: '在北方小镇长大的一对旧友，因为一场冬日里的意外而各自远走。多年后重逢，他们才发现真正需要面对的，是当年谁都没有勇气说出口的那句话。',
    tags: ['冬日', '旧友', '抒情'],
    popularity: 78,
  },
  {
    id: 'night-train',
    title: '夜行列车',
    year: 2023,
    genres: ['惊悚', '悬疑'],
    rating: 8.8,
    duration: 118,
    country: '韩国',
    director: '郑在勋',
    cast: ['李采潭', '韩素拉', '崔民载'],
    poster: 'https://readdy.ai/api/search-image?query=Thriller%20film%20poster%2C%20woman%20silhouette%20in%20a%20train%20corridor%20with%20passing%20lights%2C%20deep%20navy%20darkness%20with%20streaks%20of%20warm%20gold%2C%20tense%20cinematic%20mood&width=600&height=900&seq=lct-poster-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Suspenseful%20film%20still%2C%20night%20train%20interior%20with%20long%20corridor%20and%20flickering%20lights%2C%20deep%20blue%20shadows%20with%20warm%20gold%20highlights%2C%20cinematic%20wide%20shot&width=1280&height=720&seq=lct-still-11&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Tense%20thriller%20film%20still%2C%20woman%20watching%20the%20rain%20through%20a%20train%20window%20at%20night%2C%20deep%20navy%20tones%20with%20amber%20light%2C%20cinematic%20close%20composition&width=1280&height=720&seq=lct-still-11b&orientation=landscape',
    synopsis: '一趟深夜列车载着互不相识的乘客驶向终点，却在途中发现少了一位乘客。随着列车无法停靠，乘客之间的信任逐渐瓦解。影片密闭空间张力十足，节奏窒息。',
    tags: ['密室', '惊悚', '高能'],
    popularity: 98,
  },
  {
    id: 'city-of-glimmer',
    title: '微光城市',
    year: 2017,
    genres: ['文艺', '剧情'],
    rating: 8.1,
    duration: 112,
    country: '韩国',
    director: '金娜英',
    cast: ['李采潭', '申宇彬', '林智恩'],
    poster: 'https://readdy.ai/api/search-image?query=Artistic%20drama%20film%20poster%2C%20woman%20in%20a%20quiet%20city%20street%20at%20blue%20hour%2C%20deep%20navy%20tones%20with%20scattered%20warm%20gold%20lights%2C%20poetic%20cinematic%20composition&width=600&height=900&seq=lct-poster-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Poetic%20film%20still%2C%20empty%20city%20street%20at%20blue%20hour%20with%20glowing%20shop%20signs%2C%20deep%20navy%20and%20warm%20gold%20color%20grade%2C%20cinematic%20wide%20composition&width=1280&height=720&seq=lct-still-12&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Artistic%20film%20still%2C%20woman%20sitting%20on%20a%20rooftop%20overlooking%20city%20lights%20at%20dusk%2C%20deep%20blue%20sky%20with%20golden%20glow%2C%20cinematic%20intimate%20framing&width=1280&height=720&seq=lct-still-12b&orientation=landscape',
    synopsis: '在城市里默默生活的普通人，各自怀揣着微小的愿望。一次偶然的相遇让几条原本平行的生命轨迹交汇。影片以诗意的镜头，写给每一个在夜色中独自前行的人。',
    tags: ['文艺', '城市', '群像'],
    popularity: 76,
  },
  {
    id: 'between-mountains-seas',
    title: '山海之间',
    year: 2022,
    genres: ['冒险', '剧情'],
    rating: 8.4,
    duration: 129,
    country: '韩国',
    director: '朴敏浩',
    cast: ['李采潭', '高俊熙', '白承贤'],
    poster: 'https://readdy.ai/api/search-image?query=Adventure%20drama%20film%20poster%2C%20traveler%20woman%20standing%20on%20a%20cliff%20between%20mountains%20and%20sea%2C%20deep%20navy%20and%20warm%20gold%20epic%20landscape%2C%20cinematic%20composition&width=600&height=900&seq=lct-poster-13&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20film%20still%2C%20winding%20mountain%20road%20overlooking%20the%20sea%20at%20sunrise%2C%20deep%20blue%20mountains%20with%20warm%20golden%20light%2C%20cinematic%20wide%20aerial%20composition&width=1280&height=720&seq=lct-still-13&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Adventure%20film%20still%2C%20woman%20climbing%20a%20rocky%20path%20toward%20the%20sea%2C%20deep%20navy%20shadows%20with%20warm%20gold%20sunlight%2C%20cinematic%20composition&width=1280&height=720&seq=lct-still-13b&orientation=landscape',
    synopsis: '为了完成父亲未尽的旅程，她独自背上行囊，穿越山海去寻找一个只存在于旧照片里的地方。旅途中遇见的陌生人，让她重新理解了家与远方的意义。',
    tags: ['公路', '山海', '治愈'],
    popularity: 89,
  },
  {
    id: 'fragments-of-memory',
    title: '记忆碎片',
    year: 2021,
    genres: ['科幻', '剧情'],
    rating: 8.6,
    duration: 125,
    country: '韩国',
    director: '张铉成',
    cast: ['李采潭', '徐道贤', '郑有珍'],
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20drama%20film%20poster%2C%20woman%20face%20reflected%20in%20a%20fragmented%20mirror%2C%20deep%20navy%20and%20warm%20gold%20digital%20glow%2C%20thoughtful%20futuristic%20cinematic%20mood&width=600&height=900&seq=lct-poster-14&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20film%20still%2C%20minimal%20lab%20with%20floating%20holographic%20memory%20fragments%2C%20deep%20navy%20interior%20with%20warm%20gold%20data%20light%2C%20cinematic%20wide%20shot&width=1280&height=720&seq=lct-still-14&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Sci-fi%20film%20still%2C%20woman%20touching%20a%20glowing%20memory%20interface%20panel%2C%20deep%20blue%20ambient%20light%20with%20warm%20gold%20accents%2C%20cinematic%20close%20composition&width=1280&height=720&seq=lct-still-14b&orientation=landscape',
    synopsis: '在一项可以编辑记忆的技术问世后，一名研究员发现自己脑海中的一段记忆并不属于自己。为了找回真相，她不得不走进自己最不愿面对的过去。影片在科幻设定中探讨记忆与身份。',
    tags: ['科幻', '记忆', '思辨'],
    popularity: 94,
  },
  {
    id: 'seoul-spring',
    title: '首尔之春',
    year: 2020,
    genres: ['剧情', '历史'],
    rating: 8.2,
    duration: 133,
    country: '韩国',
    director: '李承宇',
    cast: ['李采潭', '安圣哲', '韩素拉'],
    poster: 'https://readdy.ai/api/search-image?query=Historical%20drama%20film%20poster%2C%20elegant%20woman%20in%20period%20attire%20in%20an%20old%20city%20street%2C%20deep%20navy%20and%20warm%20gold%20toned%20memoir%20style%2C%20cinematic%20composition&width=600&height=900&seq=lct-poster-15&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Period%20drama%20film%20still%2C%20old%20Seoul%20street%20in%20spring%20with%20blossoming%20trees%2C%20deep%20navy%20shadows%20with%20warm%20golden%20light%2C%20cinematic%20wide%20composition&width=1280&height=720&seq=lct-still-15&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Historical%20film%20still%2C%20woman%20standing%20in%20a%20courtyard%20with%20petals%20falling%2C%20deep%20blue%20dusk%20with%20warm%20gold%20lamp%20light%2C%20cinematic%20composition&width=1280&height=720&seq=lct-still-15b&orientation=landscape',
    synopsis: '故事发生在上世纪的城市街巷之间，一位普通女性在时代洪流中守护着自己的家庭与信念。影片以个人命运折射大时代，细腻而厚重。',
    tags: ['年代', '历史', '群像'],
    popularity: 84,
  },
  {
    id: 'the-longest-summer',
    title: '最长的夏天',
    year: 2023,
    genres: ['爱情', '青春'],
    rating: 8.5,
    duration: 114,
    country: '韩国',
    director: '朴敏浩',
    cast: ['李采潭', '金志勋', '徐允儿'],
    poster: 'https://readdy.ai/api/search-image?query=Youth%20romance%20film%20poster%2C%20young%20woman%20on%20a%20sunlit%20pier%20in%20summer%2C%20deep%20navy%20sea%20with%20warm%20golden%20sun%2C%20nostalgic%20cinematic%20mood%2C%20film%20grain&width=600&height=900&seq=lct-poster-16&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Summer%20youth%20film%20still%2C%20friends%20cyclling%20along%20a%20coastal%20road%20at%20golden%20hour%2C%20deep%20blue%20sky%20with%20warm%20gold%20light%2C%20cinematic%20wide%20composition&width=1280&height=720&seq=lct-still-16&orientation=landscape',
    still2: 'https://readdy.ai/api/search-image?query=Romantic%20youth%20film%20still%2C%20young%20couple%20watching%20fireworks%20over%20the%20sea%20at%20night%2C%20deep%20navy%20sky%20with%20warm%20gold%20sparks%2C%20cinematic%20intimate%20framing&width=1280&height=720&seq=lct-still-16b&orientation=landscape',
    synopsis: '高三毕业的那个夏天，四个少年在海边小镇许下了各自的约定。多年后重回故地，他们发现有些约定从未被忘记。影片清新明亮，关于青春、友情与初次心动。',
    tags: ['青春', '夏日', '初恋'],
    popularity: 93,
  },
];

export const heroSlides = [
  {
    id: 'dark-alley',
    kicker: '悬疑犯罪代表作',
    title: '暗巷',
    description: '一桩悬案，一段深埋的过去。跟随她的脚步，走进城市最阴暗的角落。',
  },
  {
    id: 'night-train',
    kicker: '2023 年度惊悚',
    title: '夜行列车',
    description: '深夜列车上少了一位乘客，而列车无法停靠。密闭空间中的信任正在瓦解。',
  },
  {
    id: 'spring-night',
    kicker: '高分文艺爱情',
    title: '春夜之约',
    description: '春雨中的重逢，迟到多年的告白。一段关于时间与再次选择的温柔故事。',
  },
  {
    id: 'fragments-of-memory',
    kicker: '科幻剧情新作',
    title: '记忆碎片',
    description: '当记忆可以被编辑，她却发现，脑海里有一段不属于自己的过去。',
  },
];

export const genres = ['爱情', '剧情', '悬疑', '犯罪', '家庭', '励志', '惊悚', '文艺', '冒险', '科幻', '历史', '青春'];

export const decades = [
  { label: '2020 年代', start: 2020, end: 2029 },
  { label: '2010 年代', start: 2010, end: 2019 },
];